// This index file was auto-generated by dot-index-webpack-plugin.
// To overwrite it, simply add an index.js file of your own.

export { default as Styleguide } from './Styleguide'
